import { createSelector } from '@ngrx/store'
import { CountriesState, MbSiteContextState } from '../state'
import { getMbSiteContextState } from './site-context.selectors'

export const getCountriesState = createSelector(
  getMbSiteContextState,
  (state: MbSiteContextState) => state.countries
)
export const getActiveCountry = createSelector(
  getCountriesState,
  (state: CountriesState) => state.activeCountry
)
export const getCountriesEntities = createSelector(
  getCountriesState,
  (state: CountriesState) => state.entities
)
export const getAllCountries = createSelector(
  getCountriesEntities,
  entities => entities && Object.keys(entities).map(isocode => entities[isocode])
)
